// extracted by mini-css-extract-plugin
module.exports = {"quoteWrapper":"styles_quoteWrapper__ihiXj","iconWrapper":"styles_iconWrapper__jl81j","quoteText":"styles_quoteText__DULkd"};